module.exports = __webpack_public_path__ + "img/alur-gel-4.edbba00a.png";